var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteV2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.75 8.75V14.75M6.75 8.75V14.75M2.75 4.75V16.75C2.75 17.2804 2.96071 17.7891 3.33579 18.1642C3.71086 18.5393 4.21957 18.75 4.75 18.75H12.75C13.2804 18.75 13.7891 18.5393 14.1642 18.1642C14.5393 17.7891 14.75 17.2804 14.75 16.75V4.75M0.75 4.75H16.75M3.75 4.75L5.75 0.75H11.75L13.75 4.75",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteV2);
export default __webpack_public_path__ + "static/media/delete_v2.48362c873adb11f8e22ab890522a19d3.svg";
export { ForwardRef as ReactComponent };